module.exports = __webpack_public_path__ + "static/media/37.d2a9fdcb.mp4";